import { useEffect, useReducer } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { getVehicleImage } from '~/controllers/images';
import { ICamera } from '~/domain/ICamera';
import { IImageSettings } from '~/domain/IImageSettings';
import { CACHE_TIME_2HR, STALE_TIME_2HR } from '~/queryCache';

import { useImageUrl } from './useImageUrl';

export const useImagePrefetch = (config: [ICamera, IImageSettings][]): () => void => {
  const queryClient = useQueryClient();
  const imageUrl = useImageUrl();
  const [refetchState, prefetch] = useReducer(() => ({}), {});

  useEffect(() => {

    const controllers: AbortController[] = []
    const urls = config
      .map(([camera, settings]) => {
        const src = imageUrl(camera, settings);
        return src;
      }).filter(x => !!x);

    urls.forEach(async (src) => {
      const controller = new AbortController();
      controllers.push(controller);
      await queryClient.prefetchQuery([src], getVehicleImage, {
        cacheTime: CACHE_TIME_2HR,
        staleTime: STALE_TIME_2HR,
        meta: {
          signal: controller.signal,
        },
      });
      controllers.splice(controllers.indexOf(controller), 0);
    });
    return () => {
      controllers.forEach(controller => {
        controller.abort()
      });
      urls.forEach((src) => {
        queryClient.cancelQueries([src]);
      });
    }

  }, [imageUrl, config, queryClient, refetchState]);

  return prefetch;
};
